import { createStyles, makeStyles } from '@mui/styles';
import { SimpleShowLayout, SimpleShowLayoutProps } from 'react-admin';

export function RowLayout(props: SimpleShowLayoutProps) {
  const classes = useStyles();

  return <SimpleShowLayout {...props} className={classes.layout} />;
}

const useStyles = makeStyles(() =>
  createStyles({
    layout: {
      '& .RaSimpleShowLayout-stack': {
        justifyContent: 'flex-start',
        flexDirection: 'row',
        marginBottom: 10,
        '& > div': {
          minWidth: 180,
          marginRight: 25,
        },
        '& > span': {
          minWidth: 180,
          marginRight: 25,
        },
        '& > .RaSimpleShowLayout-row': {
          marginTop: 0,
        },
      },
    },
  }),
);
